import src from "IMAGE";
export default { src, width: 46, height: 42, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
